import _extends from "@babel/runtime/helpers/extends";
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React from 'react';
import { withIconProps } from '../utils/withIconProps';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconCheckCircleFillLarge = withIconProps(props => {
  return ___EmotionJSX("svg", _extends({
    width: "32px",
    height: "32px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16ZM24.1869 10.9171C24.6935 10.2616 24.5727 9.31956 23.9172 8.81302C23.2617 8.30648 22.3196 8.42726 21.8131 9.08278L14.3553 18.734L10.0607 14.4393C9.47487 13.8535 8.52513 13.8535 7.93934 14.4393C7.35355 15.0251 7.35355 15.9748 7.93934 16.5606L13.4393 22.0606C13.7442 22.3654 14.1654 22.5244 14.5956 22.4969C15.0258 22.4694 15.4233 22.2582 15.6869 21.9171L24.1869 10.9171Z",
    fill: "currentColor"
  }));
}, 'IconCheckCircleFillLarge');
IconCheckCircleFillLarge.displayName = 'IconCheckCircleFillLarge';
export default IconCheckCircleFillLarge;